import {
  GET_WALLET_BALANCE_REQUEST,
  GET_WALLET_BALANCE_SUCCESS,
  GET_WALLET_BALANCE_FAIL,
  GET_WALLET_BALANCE_RESET,
  GET_USER_TRANSACTIONS_REQUEST,
  GET_USER_TRANSACTIONS_SUCCESS,
  GET_USER_TRANSACTIONS_FAIL,
  GET_USER_TRANSACTIONS_RESET,
  CREATE_DEPOSIT_REQUEST,
  CREATE_DEPOSIT_SUCCESS,
  CREATE_DEPOSIT_FAIL,
  CREATE_DEPOSIT_RESET,
  CREATE_WITHDRAW_REQUEST,
  CREATE_WITHDRAW_SUCCESS,
  CREATE_WITHDRAW_FAIL,
  CREATE_WITHDRAW_RESET,
  CREATE_BUYIN_REQUEST,
  CREATE_BUYIN_SUCCESS,
  CREATE_BUYIN_FAIL,
  CREATE_BUYIN_RESET,
  CREATE_CASHOUT_REQUEST,
  CREATE_CASHOUT_SUCCESS,
  CREATE_CASHOUT_FAIL,
  CREATE_CASHOUT_RESET,
  GET_ALL_TRANSACTIONS_REQUEST,
  GET_ALL_TRANSACTIONS_SUCCESS,
  GET_ALL_TRANSACTIONS_FAIL,
  GET_ALL_TRANSACTIONS_RESET,
  UPDATE_TRANSACTION_STATUS_REQUEST,
  UPDATE_TRANSACTION_STATUS_SUCCESS,
  UPDATE_TRANSACTION_STATUS_FAIL,
  UPDATE_TRANSACTION_STATUS_RESET,
  CREATE_ADMIN_TRANSACTION_REQUEST,
  CREATE_ADMIN_TRANSACTION_SUCCESS,
  CREATE_ADMIN_TRANSACTION_FAIL,
  CREATE_ADMIN_TRANSACTION_RESET,
  GET_USERS_FOR_TRANSACTION_REQUEST,
  GET_USERS_FOR_TRANSACTION_SUCCESS,
  GET_USERS_FOR_TRANSACTION_FAIL,
  GET_USERS_FOR_TRANSACTION_RESET,
  CREATE_CHIP_DEPOSIT_REQUEST, // ✅ NEW
  CREATE_CHIP_DEPOSIT_SUCCESS, // ✅ NEW
  CREATE_CHIP_DEPOSIT_FAIL, // ✅ NEW
  CREATE_CHIP_DEPOSIT_RESET,
  GET_CLUB_LEDGER_REQUEST,
  GET_CLUB_LEDGER_SUCCESS,
  GET_CLUB_LEDGER_FAIL,
  GET_CLUB_LEDGER_RESET
} from '../constants/walletConstants'





export const createAdminTransactionReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_ADMIN_TRANSACTION_REQUEST:
      return { loadingCreateAdminTransaction: true }
    case CREATE_ADMIN_TRANSACTION_SUCCESS:
      return { loadingCreateAdminTransaction: false, createAdminTransactionData: action.payload }
    case CREATE_ADMIN_TRANSACTION_FAIL:
      return { loadingCreateAdminTransaction: false, errorCreateAdminTransaction: action.payload }
    case CREATE_ADMIN_TRANSACTION_RESET:
      return {}
    default:
      return state
  }
}

export const getUsersForTransactionReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_USERS_FOR_TRANSACTION_REQUEST:
      return { loadingGetUsersForTransaction: true }
    case GET_USERS_FOR_TRANSACTION_SUCCESS:
      return { loadingGetUsersForTransaction: false, getUsersForTransactionData: action.payload }
    case GET_USERS_FOR_TRANSACTION_FAIL:
      return { loadingGetUsersForTransaction: false, errorGetUsersForTransaction: action.payload }
    case GET_USERS_FOR_TRANSACTION_RESET:
      return {}
    default:
      return state
  }
}


export const getWalletBalanceReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_WALLET_BALANCE_REQUEST:
      return { loadingGetWalletBalanceInfo: true }
    case GET_WALLET_BALANCE_SUCCESS:
      return { loadingGetWalletBalanceInfo: false, getWalletBalanceData: action.payload }
    case GET_WALLET_BALANCE_FAIL:
      return { loadingGetWalletBalanceInfo: false, errorGetWalletBalanceInfo: action.payload }
    case GET_WALLET_BALANCE_RESET:
      return {}
    default:
      return state
  }
}

export const getUserTransactionsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_USER_TRANSACTIONS_REQUEST:
      return { loadingGetUserTransactionsInfo: true }
    case GET_USER_TRANSACTIONS_SUCCESS:
      return { loadingGetUserTransactionsInfo: false, getUserTransactionsData: action.payload }
    case GET_USER_TRANSACTIONS_FAIL:
      return { loadingGetUserTransactionsInfo: false, errorGetUserTransactionsInfo: action.payload }
    case GET_USER_TRANSACTIONS_RESET:
      return {}
    default:
      return state
  }
}

export const createDepositReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_DEPOSIT_REQUEST:
      return { loadingCreateDepositInfo: true }
    case CREATE_DEPOSIT_SUCCESS:
      return { loadingCreateDepositInfo: false, createDepositData: action.payload }
    case CREATE_DEPOSIT_FAIL:
      return { loadingCreateDepositInfo: false, errorCreateDepositInfo: action.payload }
    case CREATE_DEPOSIT_RESET:
      return {}
    default:
      return state
  }
}

export const createChipDepositReducer = (state = {}, action) => { // ✅ CHANGED function name
  switch (action.type) {
    case CREATE_CHIP_DEPOSIT_REQUEST: // ✅ CHANGED
      return { loadingCreateChipDepositInfo: true } // ✅ CHANGED
    case CREATE_CHIP_DEPOSIT_SUCCESS: // ✅ CHANGED
      return { loadingCreateChipDepositInfo: false, createChipDepositData: action.payload } // ✅ CHANGED
    case CREATE_CHIP_DEPOSIT_FAIL: // ✅ CHANGED
      return { loadingCreateChipDepositInfo: false, errorCreateChipDepositInfo: action.payload } // ✅ CHANGED
    case CREATE_CHIP_DEPOSIT_RESET: // ✅ CHANGED
      return {}
    default:
      return state
  }
}


export const createBuyInReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_BUYIN_REQUEST:
      return { loadingCreateBuyInInfo: true }
    case CREATE_BUYIN_SUCCESS:
      return { loadingCreateBuyInInfo: false, createBuyInData: action.payload }
    case CREATE_BUYIN_FAIL:
      return { loadingCreateBuyInInfo: false, errorCreateBuyInInfo: action.payload }
    case CREATE_BUYIN_RESET:
      return {}
    default:
      return state
  }
}

export const createCashoutReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_CASHOUT_REQUEST:
      return { loadingCreateCashoutInfo: true }
    case CREATE_CASHOUT_SUCCESS:
      return { loadingCreateCashoutInfo: false, createCashoutData: action.payload }
    case CREATE_CASHOUT_FAIL:
      return { loadingCreateCashoutInfo: false, errorCreateCashoutInfo: action.payload }
    case CREATE_CASHOUT_RESET:
      return {}
    default:
      return state
  }
}

export const getAllTransactionsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_TRANSACTIONS_REQUEST:
      return { loadingGetAllTransactionsInfo: true }
    case GET_ALL_TRANSACTIONS_SUCCESS:
      return { loadingGetAllTransactionsInfo: false, getAllTransactionsData: action.payload }
    case GET_ALL_TRANSACTIONS_FAIL:
      return { loadingGetAllTransactionsInfo: false, errorGetAllTransactionsInfo: action.payload }
    case GET_ALL_TRANSACTIONS_RESET:
      return {}
    default:
      return state
  }
}

export const updateTransactionStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_TRANSACTION_STATUS_REQUEST:
      return { loadingUpdateTransactionStatusInfo: true }
    case UPDATE_TRANSACTION_STATUS_SUCCESS:
      return { loadingUpdateTransactionStatusInfo: false, updateTransactionStatusData: action.payload }
    case UPDATE_TRANSACTION_STATUS_FAIL:
      return { loadingUpdateTransactionStatusInfo: false, errorUpdateTransactionStatusInfo: action.payload }
    case UPDATE_TRANSACTION_STATUS_RESET:
      return {}
    default:
      return state
  }
}

export const getClubLedgerReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CLUB_LEDGER_REQUEST:
      return { loadingGetClubLedger: true }
    case GET_CLUB_LEDGER_SUCCESS:
      return { loadingGetClubLedger: false, getClubLedgerData: action.payload }
    case GET_CLUB_LEDGER_FAIL:
      return { loadingGetClubLedger: false, errorGetClubLedger: action.payload }
    case GET_CLUB_LEDGER_RESET:
      return {}
    default:
      return state
  }
}